import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { ClickOutsideModule } from '../../directives';
import { RxDatePickerRangeComponent } from './datepicker-range.component';

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, NgbDatepickerModule, ClickOutsideModule],
  declarations: [RxDatePickerRangeComponent],
  exports: [RxDatePickerRangeComponent],
})
export class RxDatePickerRangeModule {}
